export default __webpack_public_path__ + "static/media/emoji.913ef198.svg";